import type {ReactElement} from 'react';
import type {QRVCardInput} from '@Libraries/qr-code/qr-code.types';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import {QRFieldRow} from '@Components/qr-code-generator/components/qr-field-row/qr-field-row';
import {QRCollapsibleSection} from '@Components/qr-code-generator/components/qr-collapsible-section/qr-collapsible-section';
import type {QRVCardFieldSpec, QRVCardFormProps} from './qr-vcard-form.types';
import {QR_VCARD_ADDRESS_ROWS, QR_VCARD_CONTACT_ROWS} from './qr-vcard-form.types';

export function QRVCardForm({input, issues, onPatch}: QRVCardFormProps): ReactElement {
  const getFieldPatch = (inputKey: keyof QRVCardInput, value: string): Partial<QRVCardInput> => {
    const patch: Partial<QRVCardInput> = {};
    patch[inputKey] = value;
    return patch;
  };

  const renderField = (spec: QRVCardFieldSpec): ReactElement => {
    return (
      <QRField
        key={spec.inputKey}
        label={window.i18next.t(spec.labelKey)}
        placeholder={window.i18next.t(spec.placeholderKey)}
        value={input[spec.inputKey]}
        field={spec.field}
        issues={issues}
        onValueChange={(value): void => {
          onPatch(getFieldPatch(spec.inputKey, value));
        }}
      />
    );
  };

  const renderRow = (row: QRVCardFieldSpec[]): ReactElement => {
    return <QRFieldRow key={row[0].inputKey}>{row.map(renderField)}</QRFieldRow>;
  };

  return (
    <>
      {QR_VCARD_CONTACT_ROWS.map(renderRow)}
      <QRCollapsibleSection label={window.i18next.t('pmwjs_qr_generator_vcard_address_heading')}>{QR_VCARD_ADDRESS_ROWS.map(renderRow)}</QRCollapsibleSection>
    </>
  );
}
